import styled from '@emotion/styled'

import { NativeLink, spacing, Text, typography } from 'main/ui'

export const PricingContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 0 ${spacing.majorScale(3)}px 0 auto;
`

export const BulletContainer = styled.span`
  font-size: 6px;
  margin: 0 ${spacing.minorScale(1)}px;
`

export const PricingText = styled(Text)`
  font-size: ${typography.fontSize.hint};
  font-weight: ${typography.fontWeight.light};
`

export const DetailedPricingNativeLink = styled(NativeLink)`
  font-size: ${typography.fontSize.hint};
  font-weight: ${typography.fontWeight.bold};
  white-space: pre-line;
`
